// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/orgoverview/overview.actions.go

export const GET_CACHED_OVERVIEW =
  "mondoo.orgoverview.OrgOverviewService.GetCachedOverview";
